import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const state = {
	deviceType: 'PC'
}

const mutations = {
	setDeviceType(state, value) {
		state.deviceType = value
	}
}

const actions = {}

export default new Vuex.Store({
	state,
	actions,
	mutations,
	modules: {
		user
	}
})
